module.exports = __webpack_public_path__ + "static/Umme Salma.fcd227a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Umme Salma.jpg
// module id = 1244
// module chunks = 6166952557895